import axios from "axios";

const crosswalkURL = "/api/v1/crosswalks";

const crosswalkMappingsAPI = {
  fetch: crosswalkId =>
    axios.get(`${crosswalkURL}/${crosswalkId}/crosswalk_mappings`),
  create: (crosswalkId, payload) =>
    axios.post(`${crosswalkURL}/${crosswalkId}/crosswalk_mappings`, {
      crosswalk_mapping: payload,
    }),
  destroy: (crosswalkId, value_from_id, value_to_id) =>
    axios.delete(`${crosswalkURL}/${crosswalkId}/crosswalk_mappings/1`, {
      params: { value_from_id, value_to_id },
    }),
};
export default crosswalkMappingsAPI;
